import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import {
  CLIENT_SSO_HOME_PATH,
  isClientSsoUser,
} from "../../constants/clientSso";

interface RoleBasedRouteProps {
  roles: string[];
  element: React.ReactElement;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ roles, element }) => {
  const user = useSelector((state: RootState) => state.user.userInfo);

  if (!user) {
    return <Navigate to="/auth/login" />;
  }

  if (isClientSsoUser(user.group)) {
    return <Navigate to={CLIENT_SSO_HOME_PATH} replace />;
  }

  if (!roles.includes(user.group)) {
    return <Navigate to="/" />;
  }

  return element;
};

export default RoleBasedRoute;
